// Telugu. Recipe text itself stays in English for Telugu readers (recipes are written in Tamil,
// English and Tanglish), so search examples use English words.
import type { Key } from '../i18n';

export const te: Record<Key, string> = {
  'nav.main': 'ప్రధాన',
  'nav.home': 'హోమ్',
  'nav.albums': 'ఆల్బమ్‌లు',
  'nav.grocery': 'కిరాణా',
  'nav.home.label': 'Eat Recipe హోమ్',
  'common.tryAgain': 'మళ్ళీ ప్రయత్నించండి',
  'common.tryingAgain': 'మళ్ళీ ప్రయత్నిస్తున్నాం…',
  'common.back': 'వెనక్కి',
  'common.cancel': 'రద్దు',
  'common.save': 'సేవ్ చేయి',
  'common.done': 'పూర్తయింది',
  'common.loading': 'లోడ్ అవుతోంది',
  'common.seeAll': 'అన్నీ చూడండి',
  'common.addReel': 'రీల్ జోడించు',
  'common.profile': 'సెట్టింగ్‌లు, ప్రొఫైల్',
  'common.watchReel': 'రీల్ చూడండి ↗',
  'common.veg': 'శాకాహారం',
  'common.nonveg': 'మాంసాహారం',
  'common.unsure': 'తెలియదు',
  'n.recipes_one': '{n} వంటకం',
  'n.recipes': '{n} వంటకాలు',
  'n.ingredients_one': '{n} పదార్థం',
  'n.ingredients': '{n} పదార్థాలు',
  'n.steps_one': '{n} దశ',
  'n.steps': '{n} దశలు',
  'n.cooked': '{n}× వండారు',
  'n.cookedOn': '{n}× వండారు · {date}',
  'verdict.again': 'మళ్ళీ వండుతాం',
  'verdict.ok': 'పర్వాలేదు',
  'verdict.no': 'మాకు నచ్చలేదు',

  'lang.title': 'మీ భాషను ఎంచుకోండి',
  'lang.body': 'యాప్ పదాలు, Instagram బాట్ జవాబులు ఈ భాషలో ఉంటాయి. సెట్టింగ్‌లలో ఎప్పుడైనా మార్చండి.',
  'lang.ta': 'వంటకాలు, యాప్ తమిళంలో',
  'lang.en': 'వంటకాలు, యాప్ ఇంగ్లీష్‌లో',
  'lang.tg': 'thakkali, vengayam లాంటి పేర్లు · యాప్ ఇంగ్లీష్‌లో',
  'lang.continue': 'కొనసాగించు',
  'lang.saveFailed': 'మీ భాష సేవ్ కాలేదు. కనెక్షన్ చూసి మళ్ళీ ప్రయత్నించండి.',

  'greet.tiffin': 'శుభోదయం{name} · టిఫిన్ సమయం',
  'greet.lunch': 'నమస్కారం{name} · భోజన సమయం',
  'greet.teatime': 'శుభ సాయంత్రం{name} · టీ సమయం',
  'greet.dinner': 'శుభ సాయంత్రం{name} · రాత్రి భోజన సమయం',
  'greet.latenight': 'అర్ధరాత్రి{name} · ఏదైనా త్వరగా?',
  'home.title': 'ఈరోజు ఏం తినాలనిపిస్తోంది?',
  'home.search': '{n} వంటకాల్లో వెతకండి · tomato · rasam',
  'home.searchEmpty': 'వెతకండి · tomato · rasam',
  'home.mood': 'మూడ్‌కు తగ్గట్టు',
  'home.surprise': 'నిర్ణయించలేకపోతున్నారా? ఏదైనా సూచించు',
  'home.howAbout': 'ఇది ఎలా ఉంటుంది…',
  'home.cookThis': 'ఇది వండుదాం',
  'home.another': 'మరొకటి',
  'home.cookAgain': 'మళ్ళీ వండండి',
  'home.cookAgainHint': 'మీరు “మళ్ళీ వండుతాం” అన్నారు',
  'home.yourAlbums': 'మీ ఆల్బమ్‌లు',
  'home.justSaved': 'ఇప్పుడే సేవ్ చేసినవి',
  'home.allByDate': 'తేదీ ప్రకారం అన్నీ',
  'home.readingFrom': '{who} రీల్ చదువుతున్నాం',
  'home.reading': 'రీల్ చదువుతున్నాం',
  'home.landsInAlbums': 'సిద్ధమవగానే సరైన ఆల్బమ్‌లలోకి వెళ్తుంది',
  'home.addedTo': '{albums} లో జోడించాం',
  'home.noRecipe': 'ఈ రీల్‌లో వంటకం దొరకలేదు',
  'home.failed': 'ఈ రీల్ చదవలేకపోయాం · మళ్ళీ ప్రయత్నించడానికి తాకండి',
  'home.newTitle': 'మీ వంటకాలు ఇక్కడ, మూడ్ ప్రకారం సర్దబడి వస్తాయి',
  'home.newBody': 'Instagram‌లో ఏ వంట రీల్‌పైనైనా ➤ తాకి @eat.recipe కి పంపండి. నిమిషంలో వంటకం ఇక్కడ ఉంటుంది.',
  'home.openInstagram': '@eat.recipe కి మెసేజ్ చేయండి',
  'home.pasteLink': 'బదులుగా రీల్ లింక్ పేస్ట్ చేయండి',
  'reason.never_tried': 'సేవ్ చేశారు, ఎప్పుడూ వండలేదు',
  'reason.make_again_days': 'మళ్ళీ వండుతాం అన్నారు · {n} రోజుల క్రితం',
  'reason.make_again_weeks': 'మళ్ళీ వండుతాం అన్నారు · {n} వారాల క్రితం',
  'reason.not_cooked_days': '{n} రోజులుగా వండలేదు',
  'reason.not_cooked_weeks': '{n} వారాలుగా వండలేదు',
  'reason.meal.tiffin': 'టిఫిన్‌కు బాగుంటుంది',
  'reason.meal.lunch': 'భోజనానికి బాగుంటుంది',
  'reason.meal.teatime': 'టీతో బాగుంటుంది',
  'reason.meal.dinner': 'రాత్రి భోజనానికి బాగుంటుంది',
  'reason.meal.latenight': 'అర్ధరాత్రికి త్వరగా',
  'surprise.none': 'ఇక్కడ సూచించడానికి ఇంకా ఏమీ లేదు.',

  'albums.title': 'ఆల్బమ్‌లు',
  'albums.sub': '{n} వంటకాలు, వచ్చినప్పుడే మీకోసం సర్దినవి',
  'albums.sub_one': '1 వంటకం, వచ్చినప్పుడే మీకోసం సర్దినది',
  'albums.search': 'అన్ని వంటకాల్లో వెతకండి',
  'albums.mine': 'మీరు చేసినవి',
  'albums.new': 'కొత్త ఆల్బమ్',
  'albums.browse': 'ఇలా చూడండి',
  'albums.view': 'ఆల్బమ్ వ్యూ',
  'view.craving': 'మూడ్',
  'view.region': 'ప్రాంతం',
  'view.meal': 'భోజనం',
  'view.timeline': 'టైమ్‌లైన్',
  'hint.craving': 'మీ మూడ్ ప్రకారం ఎంచుకోండి — కారంగా, హాయిగా, త్వరగా లేదా తేలికగా.',
  'hint.region': 'ఓ ప్రాంతం రుచి — చెట్టినాడ్ వంటిళ్ళ నుంచి ప్రపంచ వంటకాల వరకు.',
  'hint.meal': 'ఇప్పుడు ఏ సమయం? టిఫిన్ నుంచి రాత్రి భోజనం వరకు, లంచ్‌బాక్స్ కూడా.',
  'hint.timeline': 'మీరు పంపిన ప్రతి రీల్, సేవ్ చేసిన క్రమంలో.',
  'albums.empty': 'ఇక్కడ ఇంకా ఏమీ లేదు. @eat.recipe కి కొన్ని రీల్స్ పంపండి, అవి ఆల్బమ్‌లలోకి సర్దుకుంటాయి.',
  'tl.week': 'ఈ వారం',
  'tl.month_rest': 'ఈ నెల ముందు',
  'tl.before': 'అంతకు ముందు',
  'tl.reading': '{n} చదువుతున్నాం…',

  'kind.craving': 'మూడ్',
  'kind.region': 'ప్రాంతం',
  'kind.meal': 'భోజనం',
  'kind.mine': 'మీ ఆల్బమ్',
  'album.stats': '{n} వంటకాలు · {c} వండారు · {u} ఇంకా ప్రయత్నించలేదు',
  'album.stats_one': '1 వంటకం · {c} వండారు · {u} ఇంకా ప్రయత్నించలేదు',
  'album.pin': 'హోమ్‌లో పిన్ చేయి',
  'album.unpin': 'హోమ్ నుంచి తీసేయి',
  'album.pinned': 'హోమ్‌లో పిన్ చేశాం',
  'album.unpinned': 'హోమ్ నుంచి తీసేశాం',
  'album.backToAlbums': 'ఆల్బమ్‌లకు వెనక్కి',
  'filter.label': 'వంటకాలను ఫిల్టర్ చేయండి',
  'filter.all': 'అన్నీ',
  'filter.untried': 'ఇంకా ప్రయత్నించలేదు',
  'album.pick': 'ఇందులో నుంచి నాకోసం ఒకటి ఎంచుకో',
  'album.favourites': 'మీకు ఇష్టమైనవి',
  'album.notTried': 'ఇంకా ప్రయత్నించలేదు',
  'album.cookedBefore': 'ఇంతకు ముందు వండినవి',
  'album.saved': '{date} న సేవ్ చేశారు',
  'album.shop': 'వీటిలో కొన్నింటికి షాపింగ్ చేయండి',
  'album.shopTitle': 'మీరు ఏవి వండుతున్నారు?',
  'album.shopGo': 'కిరాణా జాబితా చేయి · {n}',
  'album.empty': 'ఇక్కడ ఇంకా వంటకాలు లేవు.',
  'album.emptyMine': 'ఏదైనా వంటకం తెరిచి “ఆల్బమ్‌కు జోడించు” తాకండి.',
  'album.noMatch': 'ఈ ఫిల్టర్‌కు ఏదీ సరిపోలేదు.',
  'album.showAll': 'అన్నీ చూపించు',
  'album.rename': 'పేరు మార్చు',
  'album.delete': 'ఆల్బమ్ తొలగించు',
  'album.deleteConfirm': 'తొలగించడానికి మళ్ళీ తాకండి — వంటకాలు మీ లైబ్రరీలోనే ఉంటాయి',
  'album.notFound': 'ఈ ఆల్బమ్ ఇప్పుడు లేదు.',
  'album.nameLabel': 'ఆల్బమ్ పేరు',
  'album.namePlaceholder': 'అమ్మ స్టైల్ · ఆదివారం స్పెషల్',
  'album.create': 'ఆల్బమ్ సృష్టించు',
  'album.created': 'ఆల్బమ్ సృష్టించాం',

  'timeline.title': 'తేదీ ప్రకారం అన్నీ',
  'timeline.newest': 'కొత్తవి ముందు',
  'timeline.search': 'వంటకాలు వెతకండి',
  'timeline.empty': 'మీ లైబ్రరీ ఖాళీగా ఉంది',
  'timeline.emptyBody': 'Instagram‌లో ఏ వంట రీల్‌పైనైనా ➤ తాకి @eat.recipe కి పంపండి. కొన్ని క్షణాల్లో వంటకం ఇక్కడ కనిపిస్తుంది.',
  'timeline.noMatch': 'ఈ ఫిల్టర్‌కు ఏదీ సరిపోలేదు.',
  'timeline.showAll': 'అన్నీ చూపించు',
  'timeline.retrying': 'మళ్ళీ ప్రయత్నిస్తున్నాం — వంటకం ఇక్కడ వస్తుంది',
  'timeline.scriptHint': 'పేర్లు {script}లో; మార్చడానికి తాకండి',

  'card.reading': 'రీల్ చదువుతున్నాం',
  'card.arrives': 'వంటకం కొన్ని క్షణాల్లో వస్తుంది',
  'card.progress': 'ప్రాసెసింగ్ పురోగతి',
  'card.stages': 'అందింది · వింటున్నాం · రాస్తున్నాం',
  'card.failed': 'ఈ రీల్ చదవలేకపోయాం',
  'card.linkSafe': 'మీ లింక్ సురక్షితంగా ఉంది.',
  'card.private': 'రీల్ ప్రైవేట్ లేదా తొలగించబడింది.',
  'card.dropped': 'వింటున్నప్పుడు కనెక్షన్ తెగిపోయింది.',
  'card.wrong': 'వింటున్నప్పుడు ఏదో తప్పు జరిగింది.',
  'card.noRecipe': 'ఈ రీల్‌లో వంటకం లేదు',
  'card.noRecipeBody': 'ఇందులో ఒక వంటకం గురించి మాట్లాడారు కానీ ఎలా చేయాలో చూపలేదు. లింక్‌ను మీకోసం ఉంచాం.',
  'card.ingredientsOnly': 'పదార్థాలు మాత్రమే — రీల్‌లో దశలు చెప్పలేదు',
  'card.taVoice': 'తమిళ గొంతు',
  'card.enVoice': 'ఇంగ్లీష్ గొంతు',

  'add.title': 'రీల్ జోడించండి',
  'add.label': 'Instagram రీల్ లింక్ పేస్ట్ చేయండి',
  'add.adding': 'జోడిస్తున్నాం…',
  'add.submit': 'నా లైబ్రరీకి జోడించు',
  'add.or': 'లేదా, Instagram‌లో ఏ రీల్‌నైనా ఇక్కడికి షేర్ చేయండి',
  'add.added': 'అందింది — రీల్ చదువుతున్నాం',

  'search.label': 'వంటకాలు వెతకండి',
  'search.back': 'వెనక్కి',
  'search.clear': 'వెతుకులాట తుడిచేయి',
  'search.also': 'ఇవి కూడా వెతుకుతున్నాం',
  'search.count_one': '1 వంటకం',
  'search.count': '{n} వంటకాలు',
  'search.idle': 'వంటకం, పదార్థం లేదా క్రియేటర్ పేరుతో వెతకండి.',
  'search.none': 'ఏమీ దొరకలేదా?',
  'search.tryScripts': 'ఇంగ్లీష్ పదాలతో వెతకండి — ఉదా. tomato లేదా rasam. వంటకాలు తమిళం, ఇంగ్లీష్, Tanglish లో రాయబడతాయి.',
  'match.dish': 'వంటకం పేరు సరిపోయింది',
  'match.ingredient': 'పదార్థం:',
  'match.transcript': 'రీల్‌లో చెప్పింది:',
  'match.caption': 'క్యాప్షన్:',
  'match.tag': '“{t}” ట్యాగ్',
  'match.creator': '{t} నుంచి',
  'match.similar': 'దగ్గరి స్పెల్లింగ్',

  'recipe.notInLibrary': 'ఈ వంటకం మీ లైబ్రరీలో లేదు.',
  'recipe.share': 'వంటకం షేర్ చేయి',
  'recipe.copied': 'లింక్ కాపీ అయింది',
  'recipe.reelLength': '{d} రీల్',
  'recipe.taVoice': 'తమిళ గొంతు',
  'recipe.enVoice': 'ఇంగ్లీష్ గొంతు',
  'recipe.cookedLast': '{n}× వండారు · చివరిగా {date}',
  'recipe.today': 'ఈరోజు',
  'recipe.from': 'ఈ రీల్ నుంచి వంటకం:',
  'recipe.cookMode': 'కుక్ మోడ్',
  'recipe.addGrocery': 'కిరాణా జాబితాకు జోడించు',
  'recipe.inGrocery': 'మీ కిరాణా జాబితాలో ఉంది ✓',
  'recipe.groceryAdded': 'కిరాణా జాబితాకు జోడించాం',
  'recipe.groceryRemoved': 'కిరాణా జాబితా నుంచి తీసేశాం',
  'swipe.add': 'కిరాణాకు జోడించు',
  'swipe.remove': 'కిరాణా నుండి తీసివేయి',
  'grocery.swipeHint': 'చిట్కా: రెసిపీని కుడివైపుకు స్వైప్ చేస్తే ఇక్కడ చేరుతుంది.',
  'recipe.playReel': 'రీల్‌ను ఇక్కడే ప్లే చేయి',
  'recipe.fullScreen': 'పూర్తి స్క్రీన్',
  'recipe.closeReel': 'రీల్ మూసివేయి',
  'recipe.addAlbum': 'ఆల్బమ్‌కు జోడించు',
  'recipe.inAlbums_one': '1 ఆల్బమ్‌లో',
  'recipe.inAlbums': '{n} ఆల్బమ్‌లలో',
  'recipe.script': 'వంటకం లిపి',
  'recipe.ingredients': 'పదార్థాలు',
  'recipe.inHand': '{total} లో {n} దగ్గర ఉన్నాయి',
  'recipe.steps': 'తయారీ విధానం',
  'recipe.tgSteps': 'దశలు ఇంగ్లీష్, తమిళంలో మాత్రమే — ఇంగ్లీష్ చూపిస్తున్నాం.',
  'recipe.noSteps': 'రీల్‌లో దశలు చెప్పలేదు — విధానం కోసం రీల్ చూడండి.',
  'recipe.caption': 'క్రియేటర్ క్యాప్షన్',
  'recipe.says': 'రీల్‌లో ఏం చెప్పారు',
  'recipe.rough': 'రీల్ నుంచి ఆటోమేటిక్‌గా రాశాం; కొన్నిచోట్ల అస్పష్టంగా ఉండవచ్చు.',
  'recipe.noRecipe': 'ఈ రీల్‌లో వంటకం దొరకలేదు.',
  'recipe.readingTitle': 'వంటకం కొన్ని క్షణాల్లో ఇక్కడ వస్తుంది',
  'recipe.failedBody': 'మీ లింక్ సురక్షితంగా ఉంది. మళ్ళీ ప్రయత్నిస్తే సాధారణంగా పనిచేస్తుంది.',
  'recipe.remove': 'నా లైబ్రరీ నుంచి తీసేయి',
  'recipe.removeConfirm': 'తీసేయడానికి మళ్ళీ తాకండి',
  'recipe.removeNote': 'ఈ వంటకానికి మీ నోట్స్ కూడా తొలగిపోతాయి.',
  'recipe.removeKeep': 'దీన్ని సేవ్ చేసిన ఇతరులకు వంటకం అందుబాటులో ఉంటుంది.',
  'albumSheet.title': 'ఆల్బమ్‌కు జోడించు',
  'albumSheet.none': 'మీరు ఇంకా ఆల్బమ్ చేయలేదు.',
  'albumSheet.added': '{name} కి జోడించాం',
  'albumSheet.removed': '{name} నుంచి తీసేశాం',
  'notes.title': 'నా వంటింటి నోట్స్',
  'notes.private': 'మీకు మాత్రమే',
  'notes.cookedToday': 'ఈరోజు వండారు ✓',
  'notes.cookToday': 'ఈరోజు ఇది వండాను',
  'notes.logged_one': 'నమోదైంది · మొత్తం 1 సారి · వెనక్కి తీసుకోవడానికి మళ్ళీ తాకండి',
  'notes.logged': 'నమోదైంది · మొత్తం {n} సార్లు · వెనక్కి తీసుకోవడానికి మళ్ళీ తాకండి',
  'notes.cookedBefore_one': 'ఒకసారి వండారు · చివరిగా {date}',
  'notes.cookedBefore': '{n} సార్లు వండారు · చివరిగా {date}',
  'notes.notYet': 'ఇంకా వండలేదు',
  'notes.turnOut': 'ఎలా వచ్చింది?',
  'notes.next': 'తదుపరి సారికి నోట్',
  'notes.placeholder': 'కారం తక్కువ, ఇంకో టమాటా…',
  'notes.save': 'నోట్ సేవ్ చేయి',
  'notes.delete': 'నోట్ తొలగించు',
  'notes.today': 'ఈరోజు',

  'cook.exit': 'బయటకు',
  'cook.awake': 'స్క్రీన్ ఆన్‌లో ఉంటుంది',
  'cook.keepOn': 'స్క్రీన్ ఆన్‌లో ఉంచండి',
  'cook.switch': 'దశల భాష మార్చు',
  'cook.progress': 'దశల పురోగతి',
  'cook.step': 'దశ',
  'cook.forStep': 'ఈ దశకు కావలసినవి',
  'cook.prev': 'ముందు దశ',
  'cook.next': 'తదుపరి దశ',
  'cook.noSteps': 'ఈ వంటకంలో కలిసి వండడానికి దశలు లేవు.',
  'cook.backToRecipe': 'వంటకానికి వెనక్కి',

  'grocery.title': 'కిరాణా జాబితా',
  'grocery.summary': '{n} వస్తువులు · {b} సంచిలో · {r} వంటకాల నుంచి',
  'grocery.summary_one': '{n} వస్తువులు · {b} సంచిలో · 1 వంటకం నుంచి',
  'grocery.addRecipes': '+ వంటకాలు',
  'grocery.emptyTitle': 'ఇంకా కొనడానికి ఏమీ లేదు',
  'grocery.emptyBody': 'ఏదైనా వంటకం తెరిచి “కిరాణా జాబితాకు జోడించు” తాకండి. వేర్వేరు వంటకాల్లోని ఒకే పదార్థం ఒకే లైన్‌గా కలుస్తుంది.',
  'grocery.bringBack': '{n} వంటకాలను తిరిగి తీసుకురా',
  'grocery.bringBack_one': '1 వంటకాన్ని తిరిగి తీసుకురా',
  'grocery.goRecipes': 'నా వంటకాలకు వెళ్ళు',
  'grocery.remove': '{dish} తీసేయి',
  'grocery.skipped': '{n} వంటకాలకు ఇంకా పదార్థాల జాబితా లేదు.',
  'grocery.skipped_one': '1 వంటకానికి ఇంకా పదార్థాల జాబితా లేదు.',
  'grocery.hidePantry': 'ఇంట్లో ఉండే సాధారణ వస్తువులు దాచు',
  'grocery.hidden': '{n} దాచాం: {names}',
  'grocery.nothingHidden': 'దాచడానికి ఏమీ లేదు',
  'grocery.showingBasics': 'ఉప్పు, నూనె వంటి సాధారణ వస్తువులు చూపిస్తున్నాం',
  'grocery.vegetables': 'కూరగాయలు',
  'grocery.spices': 'మసాలాలు',
  'grocery.others': 'ఇతరాలు',
  'grocery.nRecipes': '{n} వంటకాలు',
  'grocery.asNeeded': 'అవసరమైనంత',
  'grocery.copy': 'జాబితా కాపీ చేయి',
  'grocery.copied': 'కాపీ అయింది — ఎక్కడైనా పేస్ట్ చేయండి',
  'grocery.copyFailed': 'ఈ పరికరంలో కాపీ కాలేదు',
  'grocery.whatsapp': 'WhatsApp‌లో షేర్ చేయి',
  'grocery.later': 'కిరాణా యాప్ నుంచి ఆర్డర్ — త్వరలో',
  'grocery.textTitle': 'కిరాణా జాబితా — Eat Recipe',

  'settings.title': 'సెట్టింగ్‌లు',
  'settings.account': 'మీ ఖాతా',
  'settings.via': 'Instagram DM ద్వారా సైన్ ఇన్',
  'settings.language': 'భాష',
  'settings.languageHint': 'యాప్, బాట్ జవాబులు. వంటకాలు ఇంగ్లీష్‌లో కనిపిస్తాయి.',
  'settings.saved': 'సేవ్ అయింది',
  'settings.install': 'హోమ్ స్క్రీన్‌కు జోడించండి',
  'settings.installBody': 'యాప్‌లా తెరుచుకుంటుంది, సైన్ ఇన్‌లోనే ఉంటుంది.',
  'settings.installIOS': 'Safari‌లో Share తాకి, “Add to Home Screen” ఎంచుకోండి.',
  'settings.installBtn': 'Eat Recipe జోడించు',
  'install.later': 'ఇప్పుడు కాదు',
  'install.android': 'బ్రౌజర్ మెనూ (⋮)లో “Install app” లేదా “Add to Home screen” తాకండి.',
  'settings.privacy': 'గోప్యతా విధానం ↗',
  'settings.deletion': 'మీ డేటా ఎలా తొలగిస్తాం ↗',
  'settings.signOut': 'సైన్ అవుట్',
  'settings.delete': 'నా ఖాతా తొలగించు',
  'settings.deleteConfirm': 'అన్నీ తొలగించడానికి మళ్ళీ తాకండి',
  'settings.deleteNote': 'మీ లైబ్రరీ, నోట్స్, ఆల్బమ్‌లు, వంట చరిత్ర శాశ్వతంగా తొలగిపోతాయి.',
  'settings.deleteKeep': 'ఇతరులు సేవ్ చేసిన వంటకాలు వారికి అందుబాటులో ఉంటాయి.',
  'order.groceryTitle': '{app} లో ఆర్డర్ చేయండి',
  'order.cartTitle': 'మీ {app} కార్ట్',
  'order.connectTitle': 'మీ {app} ఖాతాను జోడించండి',
  'order.connectBody': 'మీ ఫోన్ నంబర్‌తో {app} లో సైన్ ఇన్ చేస్తారు. తర్వాత Eat Recipe ఈ జాబితా నుంచి మీ {app} కార్ట్ నింపుతుంది; చెల్లింపు {app} లో.',
  'order.connect': '{app} జోడించు',
  'order.connectFailed': '{app} జోడించడం పూర్తికాలేదు. దయచేసి మళ్ళీ ప్రయత్నించండి.',
  'order.emptyList': 'మీ కిరాణా జాబితా ఖాళీగా ఉంది.',
  'order.finding': '{app} లో మీ వస్తువులు వెతుకుతున్నాం…',
  'order.pickHint': 'ప్రతి వస్తువుకు ప్యాక్ ఎంచుకోండి. ఇంట్లో ఉండే సాధారణ వస్తువులు వదిలేశాం.',
  'order.recipeNeeds': 'వంటకాలకు కావలసింది {q}',
  'order.pantry': 'సాధారణంగా ఇంట్లో ఉంటుంది',
  'order.notFound': '{app} లో దొరకలేదు',
  'order.pack': 'ప్యాక్',
  'order.quantity': 'పరిమాణం',
  'order.less': 'ఒకటి తక్కువ',
  'order.more': 'ఇంకొకటి',
  'order.build': 'నా {app} కార్ట్ నింపు · {n} వస్తువులు',
  'order.build_one': 'నా {app} కార్ట్ నింపు · 1 వస్తువు',
  'order.building': 'మీ కార్ట్ నింపుతున్నాం…',
  'order.payInApp': 'ధరలు {app} వి, చెకౌట్‌లో మారవచ్చు. డెలివరీ సమయం, చెల్లింపు {app} లో ఎంచుకోండి.',
  'order.openToPay': 'చెల్లించడానికి {app} తెరవండి',
  'order.cartReady': 'మీ కార్ట్ సిద్ధం — చెకౌట్ కోసం {app} యాప్ తెరవండి.',
  'order.editItems': 'వస్తువులు మార్చు',
  'food.title': '{app} లో ఆర్డర్ చేయండి',
  'food.connectBody': 'మీ ఫోన్ నంబర్‌తో {app} లో సైన్ ఇన్ చేస్తారు. Eat Recipe ఈ వంటకాన్ని దగ్గర్లో వెతికి, మీరు నిర్ధారించాకే ఆర్డర్ చేస్తుంది.',
  'food.deliverTo': 'ఇక్కడికి డెలివరీ',
  'food.address': 'చిరునామా',
  'food.change': 'మార్చు',
  'food.noAddress': '{app} లో సేవ్ చేసిన చిరునామా లేదు. ముందు {app} యాప్‌లో జోడించండి.',
  'food.dish': 'వంటకం పేరు',
  'food.search': 'వెతకండి',
  'food.none': 'ప్రస్తుతం {app} లో దగ్గర్లోని ఏ రెస్టారెంట్‌లోనూ ఇది లేదు.',
  'food.soldOut': 'అయిపోయింది',
  'food.customizable': 'ఆప్షన్లు కావాలి — దీన్ని {app} యాప్‌లో ఆర్డర్ చేయండి',
  'food.review': 'ఆర్డర్ చూడండి',
  'food.reviewTitle': 'మీ ఆర్డర్ చూడండి',
  'food.payWith': 'చెల్లింపు విధానం',
  'food.noPayment': 'ఇక్కడ ఈ ఆర్డర్‌కు {app} ఏ చెల్లింపు విధానమూ ఇవ్వడం లేదు.',
  'food.note': 'రెస్టారెంట్‌కు నోట్ (ఐచ్ఛికం)',
  'food.notePlaceholder': 'కారం తక్కువ, ఉల్లిపాయ వద్దు…',
  'food.cancelNote': 'ఆర్డర్లు నేరుగా రెస్టారెంట్‌కు వెళ్తాయి. క్యాష్ ఆర్డర్లను ఇక్కడ రద్దు చేయలేరు; అవసరమైతే {app} సపోర్ట్‌ను సంప్రదించండి.',
  'food.choosePayment': 'ఎలా చెల్లించాలో ఎంచుకోండి',
  'food.place': 'ఆర్డర్ చేయి · {total} · {method}',
  'food.placing': 'మీ ఆర్డర్ చేస్తున్నాం…',
  'food.doneTitle': 'మీ ఆర్డర్',
  'food.placed': '{app} ఆర్డర్ అయింది',
  'food.orderId': 'ఆర్డర్ {id}',
  'food.eta': '{eta} లో వస్తుంది',
  'food.refresh': 'స్థితి చూడండి',
  'food.payNow': 'మీ UPI యాప్‌లో చెల్లించండి',
  'food.payBody': 'చెల్లింపు పూర్తవగానే ఆర్డర్ {app} లో నమోదవుతుంది.',
  'food.openUPI': 'UPI యాప్ తెరవండి',
  'food.waiting': 'చెల్లింపు కోసం ఎదురుచూస్తున్నాం…',
  'food.failed': 'ఆర్డర్ పూర్తికాలేదు',
  'recipe.orderIt': 'వండాలని లేదా? {app} లో ఆర్డర్ చేయండి',
  'grocery.orderOn': '{app} లో ఆర్డర్ చేయండి',
  'settings.apps': 'ఆర్డర్ యాప్‌లు',
  'settings.appsHint': 'కిరాణా జాబితాతో కార్ట్ నింపడానికి లేదా వంటకం ఆర్డర్ చేయడానికి ఒక యాప్ జోడించండి.',
  'settings.connected': 'జోడించబడింది',
  'settings.connect': 'జోడించు',
  'settings.disconnect': 'తీసేయి',
  'settings.appConnected': '{app} జోడించాం',
  'settings.appDisconnected': '{app} తీసేశాం',
  'settings.grocery': 'కిరాణా',
  'settings.food': 'ఫుడ్ డెలివరీ',
  'apps.title': 'ఈ కిరాణా ఆర్డర్ చేయండి',
  'apps.sub': '{n} వంటకాల నుంచి. ఆర్డర్ చేయడానికి యాప్ ఎంచుకోండి.',
  'apps.sub_one': '1 వంటకం నుంచి. ఆర్డర్ చేయడానికి యాప్ ఎంచుకోండి.',
  'apps.none': 'ఈ సర్వర్‌లో ఇంకా కిరాణా యాప్ సెట్ కాలేదు.',
  'apps.signIn': 'మీ ఫోన్ నంబర్‌తో సైన్ ఇన్ చేయండి',
  'apps.note': 'Eat Recipe యాప్ కార్ట్ నింపి దాని ధరలే చూపిస్తుంది. మీరు నిర్ధారించే వరకు ఏదీ ఆర్డర్ కాదు.',
  'soon.badge': 'త్వరలో',
  'soon.orderOn': '{apps}లో ఆర్డర్',
  'soon.body': '{app} Eat Recipe‌ను ఆమోదించగానే ఇక్కడి నుండి ఆర్డర్ చేయవచ్చు.',
  'grocery.orderAll': 'ఈ కిరాణా ఆర్డర్ చేయండి',
  'order.connectBody2': 'మీ ఫోన్ నంబర్‌తో {app} లో సైన్ ఇన్ చేస్తారు. తర్వాత Eat Recipe ఈ జాబితాతో కార్ట్ తయారు చేసి {app} ధరలు చూపిస్తుంది; మీరు నిర్ధారించే వరకు ఏదీ ఆర్డర్ కాదు.',
  'order.reviewN': 'ఆర్డర్ చూడండి · {n} వస్తువులు',
  'order.reviewN_one': 'ఆర్డర్ చూడండి · 1 వస్తువు',
  'order.notDeliverable': 'ప్రస్తుతం {app} ఈ చిరునామాకు ఈ కార్ట్ డెలివరీ చేయలేదు.',
  'order.realOrder': 'ఇది మీ {app} కార్ట్‌లో ఉన్నవాటిని మారుస్తుంది. ఆర్డర్ నిజమైనది: {app} డెలివరీ చేసి, మీరు ఎంచుకున్న విధానంలో డబ్బు తీసుకుంటుంది.',
  'order.payTitle': 'ఆర్డర్ పూర్తి చేయడానికి చెల్లించండి',
  'order.payNow': 'చెల్లింపు పేజీ తెరవండి',
  'order.finishInApp': '{app} యాప్‌లో పూర్తి చేయండి',
  'order.finishInAppNote': 'మీ కార్ట్ ఇప్పటికే {app} లో ఉంది: అక్కడ ఇంకా జోడించండి, కూపన్లు వాడండి, చెల్లించండి.',
  'order.cancelInApp': 'రద్దు చేయాలా? {app} యాప్ తెరవండి (ఆర్డర్ {id}). చెల్లించని ఆర్డర్లు డెలివరీ కావు.',
  'order.pickedOf': '{total} లో {n} ఎంచుకున్నారు',
  'order.basicsLeftOut': 'ఇంట్లో ఉండే సాధారణ వస్తువులు వదిలేశాం',
  'order.include': '{item} చేర్చు',
  'order.otherPacks': 'ఇతర ప్యాక్‌లు',
  'order.itemsFeesNext': '{n} వస్తువులు · ఫీజులు తదుపరి దశలో',
  'order.itemsFeesNext_one': '1 వస్తువు · ఫీజులు తదుపరి దశలో',
  'food.dishesNear': 'మీ దగ్గర {n} వంటకాలు',
  'food.dishesNear_one': 'మీ దగ్గర 1 వంటకం',
  'food.add': 'జోడించు',
  'food.soldOutShort': 'అయిపోయింది',
  'food.optionsInApp': 'ఆప్షన్లు {app} లో',
  'food.oneItem': '{n} వస్తువులు · {total}',
  'food.oneItem_one': '1 వస్తువు · {total}',
  'order.payInApp2': 'ఈ ఆర్డర్ చెల్లింపు పూర్తి చేయడానికి {app} యాప్ తెరవండి.',
  'order.checkFirst': 'మళ్ళీ ప్రయత్నించే ముందు, రెండుసార్లు ఆర్డర్ కాకుండా {app} యాప్‌లో మీ ఆర్డర్లు చూడండి.',

  'search.placeholder': 'tomato · rasam · dosa',
  'script.ta': 'తమిళం',
  'script.en': 'ఇంగ్లీష్',
  'script.tg': 'Tanglish',
  'cook.done': 'పూర్తయింది',
  'recipe.contentLang': 'వంటకాలు తమిళం, ఇంగ్లీష్, Tanglish లో రాయబడతాయి.',
  'auth.checking': 'మీ లింక్ చెక్ చేస్తున్నాం…',
  'auth.isYou': 'ఇది మీరేనా?',
  'auth.yourAccount': 'మీ ఖాతా',
  'auth.linkFrom': 'ఈ లింక్ {h} తో మీ చాట్ నుంచి వచ్చింది. ఇది ఒక్కసారే పనిచేస్తుంది, కాబట్టి దీనితో ఇంకెవరూ మీ లైబ్రరీ తెరవలేరు.',
  'auth.continueAs': '{who} గా కొనసాగించు',
  'auth.notYou': 'మీరు కాదా? మీ సొంత లింక్ పొందండి',
  'auth.opening': 'మీ లైబ్రరీ తెరుస్తున్నాం…',
  'auth.used': 'ఈ లింక్ ఇప్పటికే వాడబడింది',
  'auth.usedBody': 'ప్రతి లింక్ మీ లైబ్రరీని ఒక్కసారి, కొద్దిసేపు మాత్రమే తెరుస్తుంది. కొత్తది కొన్ని సెకన్లలో వస్తుంది.',
  'auth.stepOpen': '{h} తో మీ చాట్ తెరవండి',
  'auth.stepSend': '{w} పంపి కొత్త లింక్ తాకండి',
  'auth.newLink': 'కొత్త లింక్ పొందండి',
  'auth.safe': 'మీరు సేవ్ చేసిన వంటకాలు సురక్షితం — ఏమీ పోలేదు.',
  'auth.checkFailed': 'మీ లింక్ చెక్ చేయలేకపోయాం',
  'auth.checkConn': 'దయచేసి కనెక్షన్ చూసి మళ్ళీ ప్రయత్నించండి.',
  'auth.hello': 'నమస్కారం,',
  'auth.friend': 'మిత్రమా',
  'auth.summaryEmpty': 'ఏదైనా వంట రీల్‌ను @eat.recipe కి షేర్ చేయండి, అది ఇక్కడ కనిపిస్తుంది.',
  'auth.summary': 'మీ DM ల నుంచి {n} వంటకాలు సేవ్ అయ్యాయి.',
  'auth.summary_one': 'మీ DM ల నుంచి 1 వంటకం సేవ్ అయింది.',
  'auth.reading': '{n} ఇంకా చదువుతున్నాం.',
  'auth.reading_one': '1 ఇంకా చదువుతున్నాం.',
  'auth.installBody': 'యాప్‌లా తెరుచుకుంటుంది, సైన్ ఇన్‌లో ఉంటుంది, తక్కువ డేటా వాడుతుంది.',
  'auth.openLibrary': 'నా లైబ్రరీ తెరవండి',
  'signin.bubble': 'ఇదిగో మీ ఒక్కసారి లింక్. లైబ్రరీ తెరవడానికి తాకండి →',
  'signin.title': 'మీ వంటకాలు మీ DM లో ఎదురుచూస్తున్నాయి',
  'signin.step1': 'Instagram‌లో {h} తెరవండి',
  'signin.step2': '{w} అనే పదం పంపండి',
  'signin.step3': 'మేము పంపే లింక్‌ను తాకండి. పాస్‌వర్డ్ ఎప్పుడూ అవసరం లేదు.',
  'signin.message': '@eat.recipe కి మెసేజ్ చేయండి',
  'signin.have': 'లింక్ ఇప్పటికే ఉందా? ఈ ఫోన్‌లో తెరిస్తే చాలు.',
};
